import React from 'react';
import { Alert } from 'antd';
import { PageContainer } from '../Page/Page.styled';
import { useTranslate } from '@/translations';

export const NoAccessAlert = () => {
  const { t } = useTranslate();

  return (
    <PageContainer>
      <Alert type="error" message={t('noAccessAlert')} />
    </PageContainer>
  );
};
